<template>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
    @submit.prevent="createUser"
  >
    <v-card>
      <v-card-title primary-title>
        Skapa användare
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row>
            <v-col>
              <v-text-field
                filled
                v-model="model.first_name"
                label="Förnamn"
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                filled
                v-model="model.last_name"
                :rules="[rules.required]"
                label="Efternamn"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                filled
                v-model="model.email"
                :readonly="mailReadOnly"
                @focus="mailReadOnly = false"
                :rules="[rules.required, rules.email]"
                label="Email"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                filled
                label="Nytt lösenord"
                type="password"
                :rules="[rules.required]"
                v-model="model.password"
                placeholder="Skriv in nytt lösenord"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                filled
                label="Nytt lösenord igen"
                type="password"
                :rules="[rules.required]"
                v-model="newPasswordConfirm"
                placeholder="Skriv in nytt lösenord igen"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <p class="error--text" v-for="(error, $i) in errors" :key="$i">
                {{ error }}
              </p>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-combobox
                v-model="model.access_rights"
                :items="sortedAccesses"
                label="Behörigheter"
                item-text="name_se"
                item-value="id"
                multiple
                chips
              ></v-combobox>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn tile text @click="close" :disabled="pendingCreate">
          Avbryt
        </v-btn>
        <v-btn tile color="primary" text type="submit" :loading="pendingCreate">
          Skapa
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import rules from '@/common/validationRules.js'
import gql from 'graphql-tag'
import orderBy from 'lodash.orderby'

export default {
  name: 'UserCreate',

  data: () => ({
    pendingCreate: false,
    rules,
    valid: true,
    mailReadOnly: true,
    newPasswordConfirm: '',
    model: {
      email: '',
      first_name: '',
      last_name: '',
      access_rights: [],
      password: ''
    }
  }),

  apollo: {
    accesses: {
      query: gql`
        query {
          accesses {
            id
            name_se
          }
        }
      `
    }
  },

  computed: {
    sortedAccesses() {
      return orderBy(this.accesses || [], ['name_se'], ['asc'])
    },

    errors() {
      const errors = []

      if (this.model.password !== this.newPasswordConfirm) {
        errors.push('Lösenorden måste vara identiska')
      }

      return errors
    }
  },

  methods: {
    close() {
      this.$emit('close')
    },

    async createUser() {
      const isValid = await this.$refs.form.validate()

      if (!isValid || this.errors.length) return

      this.pendingCreate = true

      await this.$apollo.mutate({
        mutation: gql`
          mutation createUser($payload: CreateUserInput!) {
            createUser(payload: $payload) {
              id
            }
          }
        `,

        variables: {
          payload: {
            ...this.model,
            access_rights: this.model.access_rights.map(x => x.id)
          }
        }
      })

      this.pendingCreate = false
      this.$emit('confirm')
    }
  }
}
</script>
